import { BettingTypeSelectorsStore as GPBettingTypeSelectorsStore } from "@gp/offer";

export class BettingTypeSelectorsStore extends GPBettingTypeSelectorsStore {
	constructor() {
		super(4);
	}
}
